import { render, staticRenderFns } from "./ChartPercentualParticipacao.vue?vue&type=template&id=498cf19a"
import script from "./ChartPercentualParticipacao.vue?vue&type=script&lang=js"
export * from "./ChartPercentualParticipacao.vue?vue&type=script&lang=js"
import style0 from "./ChartPercentualParticipacao.vue?vue&type=style&index=0&id=498cf19a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports